export const UPDATE_CONVERSION_STATE = 'UPDATE_CONVERSION_STATE'
export const FUNNEL_DATA_LOADED = 'FUNNEL_DATA_LOADED'


// WEBPACK FOOTER //
// ./src/data/redux/conversion_details/actiontypes.js